import { createFileRoute } from "@tanstack/react-router";
import AutomatischIndelenTennisspelers from "@/pages/AutomatischIndelenTennisspelers";

export const Route = createFileRoute("/automatisch-indelen-tennisspelers")({
  head: () => ({
    meta: [
      { title: "Tennisspelers automatisch indelen op niveau & banen | De Hussel App" },
      { name: "description", content: "Tennisspelers automatisch indelen op niveau, gespeelde rondes en eerlijke speeltijd. Lees hoe het algoritme van De Hussel App werkt — en wat het voor jouw club doet." },
      { property: "og:title", content: "Tennisspelers automatisch indelen op niveau & banen | De Hussel App" },
      { property: "og:description", content: "Tennisspelers automatisch indelen op niveau, gespeelde rondes en eerlijke speeltijd. Lees hoe het algoritme van De Hussel App werkt — en wat het voor jouw club doet." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/automatisch-indelen-tennisspelers" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/automatisch-indelen-tennisspelers" }],
  }),
  component: AutomatischIndelenTennisspelers,
});
